// https://react-icons-kit.vercel.app/guide DOCS
import { Icon as IconKit } from "react-icons-kit";
import { TIconProps } from "./Icon.type";

export default function Icon({ icon, onClick, className, style }: TIconProps) {
  return (
    <IconKit
      icon={icon}
      className={className}
      onClick={onClick}
      style={{ cursor: "pointer", ...style }}
    />
  );
}
